export default __webpack_public_path__ + "static/taking-nuplazid-icon-9a7945c8e987468fed150f3046be4efa.svg";